// extracted by mini-css-extract-plugin
export default {"returnButton":"SubscriptionCancelPage_returnButton__ch4Ha"};